import {BBModel} from "../../bb_model";
import {ClientModel} from "../core/client";
import {member} from "../../services/member";

class MemberMemberModel extends ClientModel {

    static $refresh(_member) {
        return member.refresh(_member);
    }

    static $current() {
        return member.current();
    }

    static $updateMember(_member, params) {
        return member.updateMember(_member, params);
    }

    static $sendWelcomeEmail(_member, params) {
        return member.sendWelcomeEmail(_member, params);
    }

    getBookings(params) {
        return BBModel.Member.Booking.$query(this, params);
    }
}

export {
    MemberMemberModel
}